export enum AuthStep {
  Email = 'email',
  Password = 'password',
  Review = 'review',
  Sso = 'sso',
}
